
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index1YJEd33oCZRX_Mwm6dwRV01Zj8TqUiD90YyCX6bvJCMMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/index.vue?macro=true";
import { default as loginfIUgyOoDOmrorE44DBeFzPxHI5Bhn2PVy7Hh5_R_OpUMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Auth/login.vue?macro=true";
import { default as logoutW1jbM1MlsriK_tRTB1AGlvLZ4guWrzxKTBuJZ52vgoAMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Auth/logout.vue?macro=true";
import { default as indexqUHJB4Ed_scwwLJTjCoGPOYMH1OYH_0_1jjFDbECd6QMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Staff/index.vue?macro=true";
import { default as indextIlhE5ud55sto0JfpowSvGjo0dkcyfLFv644Q0Lqv40Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/index.vue?macro=true";
import { default as indexgWGZn8gLyJsV6ik11c_Ut1N7_HXeN9YzAn820ROIJQ4Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/index.vue?macro=true";
import { default as index3jLjWpRWC3jFky7e_9HO9US8RMB8kTeJgNLMsQqnrSEMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Events/index.vue?macro=true";
import { default as _91uuid_93IrC9sfBnKbOpvPl7ElAgrwpFDCPfM_9vpVC4tNCcvN8Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Staff/[uuid].vue?macro=true";
import { default as createxyFeS68EG0Gyl_pm_NwJQzi3wAsQq8PqhvGYwoCAe5IMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Staff/create.vue?macro=true";
import { default as babiesRCekVMQBCktllThApQPeVcakadle5XLIaD3Mwm8WYeUMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/babies.vue?macro=true";
import { default as indexJDchaii8f1lAVu2W22axQOR_amHTa8ldFPDFRy384cAMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/index.vue?macro=true";
import { default as createfWhatgtESdKZWCVAvr5SWDT_K6XCZeP8B_g3jYDnzDAMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/create.vue?macro=true";
import { default as indexsN_CA_TxyyWU9pQEiiCfOOjUg9UXOK20VHmKyO53IhwMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Demands/index.vue?macro=true";
import { default as _91uuid_93dgHoD_VrH1BCCXFGEghKx6WsxcDzZ802ZIpsEbiGarQMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Events/[uuid].vue?macro=true";
import { default as codacQnI0_vFHEl9Vud9cINuoFEKq0yGUTutS_ra1b7HV0gMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Invoices/coda.vue?macro=true";
import { default as _91id_93bsESn0ugMZjr9FLlGmrLxDbASYCdaer5TB2uc9vmyFEMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Messages/[id].vue?macro=true";
import { default as indexAleqePdwccSyJvQ4GS4rETpCBVpfOoOQrDPtUIK71IcMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Parents/index.vue?macro=true";
import { default as one9xFYEKgjg3pdNDQNgxJ3Z7GS4ws7jVAzc3oblmKE5VQMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Reporting/one.vue?macro=true";
import { default as financeDjaZodH_ILgEZtriG1Xx2piKzDpfGK_4l26gQpdPNQcMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/finance.vue?macro=true";
import { default as medicalxj9dQ8DhrOILNwVXZBUmmASYpirLX7WTFEr7Dv036jAMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/medical.vue?macro=true";
import { default as indexAgT_EDeQR4P_aJMuCLrNm7efvpda76dhezumsEBc3zUMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Activity/index.vue?macro=true";
import { default as indexT_Vho5JoUroDUKJgPbVE0VgkDt_qrxMDbgms7_IYdHIMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Invoices/index.vue?macro=true";
import { default as indexYsT98BwrVZ7OsjVrazQcZp8N9oYl7qHpdrFQQM5rVnUMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Messages/index.vue?macro=true";
import { default as indexwQ_dRnIxzimBoAZml08bwF_xYVr4DIxw1a9nnEgL__0Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Payments/index.vue?macro=true";
import { default as calendarFyvaiw7doPzdH9WKp9IqUKcCm7x8tQfL9wt821tAXPgMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Staff/calendar.vue?macro=true";
import { default as dayNDnpPXUJ1DZDQxjO7AlaXhScN204VTOxr_NwqozAr60Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Attendances/day.vue?macro=true";
import { default as archivedBn2UHS06CFnBPq6bl1A_PAf8QUsgPKnX3lAA_u6HNUQMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/archived.vue?macro=true";
import { default as _91uuid_93Z_eF4h1cA76NXXgD9uQ3q6wJwiH1kmq4KDz1yjZEhGUMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Invoices/[uuid].vue?macro=true";
import { default as createF3FlIOUZfrKTi4P5Z1OaZesvxHiN1_y0vNLUzyI0nNgMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Invoices/create.vue?macro=true";
import { default as createjd052R_bKGcNJI_8UDDbMwLW8pSAFy7dvy12P_H3_FkMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Messages/create.vue?macro=true";
import { default as crecheE7CzfEIQQLcprhD9dYslIJvps0BjsomixftViQjwmAkMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Settings/creche.vue?macro=true";
import { default as weekhokaW1AIqoF4qZIIDAHIRVX480V9s7AI6wunntqzKV0Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Attendances/week.vue?macro=true";
import { default as indexsVJSRamL58pG_V2JVuRbE36HnVM5uXVyde0zArLT0EEMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Classrooms/index.vue?macro=true";
import { default as doctorsLfCT1vRnktX90Ecd6dt_iHbN8uvO_eSc_HKZ_kxGOQoMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Settings/doctors.vue?macro=true";
import { default as finance_Vio_xDE6rkET_SBtG_jbOr79xRavueLC93MTfnOMD0Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Settings/finance.vue?macro=true";
import { default as indexrIYm_6g47PwQJJRfSLNApHA77uTgsnjoXHu7K_18FxAMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Attendances/index.vue?macro=true";
import { default as forecasteIXDDe89r1rxxGnKs0VTf0ogf0_0eQMdJTXndAaY2BkMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Invoices/forecast.vue?macro=true";
import { default as balancesjQu95fLGqMf9_7PyzgrA5bdLYE_A9L95kHceglcWq4kMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Payments/balances.vue?macro=true";
import { default as pro_45oneB2YQvSB4AiWVoMsBjC81oQUdK_BQkUqilSVzk9gk_BUMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Reporting/pro-one.vue?macro=true";
import { default as schedulevu_LkyqhQdHO2WZuHVhs7cFoka10XkoBxNjtM2u5PPgMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Settings/schedule.vue?macro=true";
import { default as attendancesMGDTfPOP2hYZeTZUrAO_m5P0UlKdcm8FImFVBV_HZosMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/attendances.vue?macro=true";
import { default as indexZ27D4AG_QxPVxu3bKuHoAuETT_RNjvyKINHhJ6yS3YMMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Scan/index.vue?macro=true";
import { default as indexgsDNOSQzOa8q_4WGZHH4mCAZM8w2DtM72UyTzGFsBT4Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Availability/index.vue?macro=true";
import { default as indexECfQoPnSa3TsVpSYqxNXxim84ka2JDhO_KPWr79VAm8Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/index.vue?macro=true";
import { default as documents8jMc445l9NeFg8utcGKJO5bjWARC3GAQDdf1ndGa9xQMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Settings/documents.vue?macro=true";
import { default as availabilityxI4BJ_2f_xyNNWrDnMrnHvVz0AT_4we9PW1TKej_QuMMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/availability.vue?macro=true";
import { default as indexBwjpP9vedCiVPMN6tJHsDoTGsSSMvjgZlVODPi3ktFoMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Staff/index.vue?macro=true";
import { default as index7tjDfjPSnPsXAPQGJLC9YWVR2HrhT4mlca58HEMKJ6IMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/MedicalVisits/index.vue?macro=true";
import { default as indexL_baYViNIb7LXRj_4ywx6W4tmsWFqpMfvCjRrsgb8KUMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Registrations/index.vue?macro=true";
import { default as registrationsmNIO4f_DUDgWX26ofbnzxya_FBLDjX5Nbceks74ZVCgMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/registrations.vue?macro=true";
import { default as indexJL5HstLg6GcOZdjKe_dydnIujliMHDwt69uMR_l4kJIMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Babies/index.vue?macro=true";
import { default as day2S7RrA56_nSrJi5ivYHhyAjLnNokCclOUSyqTIER4_oMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Calendar/day.vue?macro=true";
import { default as index2IStO2v_10zA1lnTsLVo7whjmEjUrvULqKNNMxbiNLsMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Social/index.vue?macro=true";
import { default as createypwOc6vE34JIG3LcMG3lB3nKyVy1ujOoHrr3fI3GCWgMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/MedicalVisits/create.vue?macro=true";
import { default as index3p82JJNRUzunUgwGAOoskbsWcuNJmNABdyJ_vvAFR2AMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Parents/[uuid]/index.vue?macro=true";
import { default as mailsA_VN8_bXGW0zdPmGW5fAKgSWaXq8Wlu2DYpXG8R4xOYMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Parents/[uuid]/mails.vue?macro=true";
import { default as _91uuid_93azyUWowM_b564Tz_HWJv2g_suz3gXDuXHkREfjmsqMcMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Registrations/[uuid].vue?macro=true";
import { default as createRTBIzQTiiTA2d4sL_rjLj3e2aYN2gPa2QiUy9ThzP7gMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Registrations/create.vue?macro=true";
import { default as _91uuid_93ZD6X0VMljC46KV9XFiK4eCldwFdY6lnVb07e1qGdf2EMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Babies/[uuid].vue?macro=true";
import { default as createyGYH3tsgrKf_lfyasCJwxCQPCJOihyFkZWytQDg6S2gMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Babies/create.vue?macro=true";
import { default as _91id_93zUdHeJjzYipxvgr2xuWZ3EIgn1cB_7301f6zTVF5pY8Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Messages/[id].vue?macro=true";
import { default as socialLvjWvnp7Rl5Vq87qjB7kKwTSAxhnIQ6TnvXgEjFS0CoMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/social.vue?macro=true";
import { default as babiesBfOu93_Q_gfO9J9ddrxkCd2bppTMiF7w6whyev0zBrcMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Parents/[uuid]/babies.vue?macro=true";
import { default as attendancesESWR_ClFzmxrzMh8G18vcaA8jAKqdf1dvM_Z6tGt7KgMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Reporting/attendances.vue?macro=true";
import { default as indexeSRv6WFPZxF7O4wFrofGHgpOdvtWejrnIaBKOKafAooMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Activity/index.vue?macro=true";
import { default as month0w69lidYs4hK6NTTD9e_mz5NMnARo9tIlhPWFYRhWmQMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Calendar/month.vue?macro=true";
import { default as indexKm20CTsB78biBmOvKYyxkLBPw4dtAGbGCq44zf_ab98Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Messages/index.vue?macro=true";
import { default as accountITpvfb7C__RZS_vHHeduwHVsKab3cdUhWTfabDcql8kMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Parents/[uuid]/account.vue?macro=true";
import { default as mailtemplatesgOlFcDfHi_SWkwVan3jsk2RTSMbVp2EXq0YxirKsWSUMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Settings/mailtemplates.vue?macro=true";
import { default as createsQAskPgJQe0KiHVqodpLv2qNnoL4FBYU9vgTbMWV2eMMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Messages/create.vue?macro=true";
import { default as indexWAO8g8yXdCPa650cGb7z42hWE90jJTYNLwa4o4ZtdkUMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Classrooms/[uuid]/index.vue?macro=true";
import { default as invoiceseSexEt78X008RZqYLAi5J85_ctEkboaEV879XbSBt0UMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Parents/[uuid]/invoices.vue?macro=true";
import { default as remunerationseKkIUyOZcBJ6yLwQolGK9hE4N20_OWM577237tVu6RMMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Reporting/remunerations.vue?macro=true";
import { default as indexIbBQsWZAl82lAN2N_VRiBJqXJQhcKBPzZ_vWNl6fI_IMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/Sms/index.vue?macro=true";
import { default as index1JtXoXL6qRFNLfKl_MBmRTkn_oBxUEFUvQDrLUTuLT0Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Staff/index.vue?macro=true";
import { default as createNMylSAsrTQ1lYcc44XWCjHtaQ3d5fT3VHAEU2_AfAYoMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Registrations/aes/create.vue?macro=true";
import { default as indexIGkoqZef63Tw_MJI7ZmUWNJtCWL2qd724OTC9U_Nmv8Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Attendances/index.vue?macro=true";
import { default as _91uuid_9371j1y0mYjuubHcnWr1YWWtiymzy0pXR2KPLiwsvSiocMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/Sms/[uuid].vue?macro=true";
import { default as createrRRza_Ep9l2sIKlJmILx7nPsa2BZm2t8X4XJVWG4b_EMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/Sms/create.vue?macro=true";
import { default as edit1hdvmd3W5MTyQFCAsYCpmIbuBl1w1U3tQfHVU5Qt4toMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/MedicalVisits/[uuid]/edit.vue?macro=true";
import { default as indexTk7_8Jc6Ss7r7FGDqr9PA5gSj9R7ma_3rBMMwTSrMfwMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Social/index.vue?macro=true";
import { default as _91uuid_93LHoDF82iZwJ7gEb2PBetmvAJ61Unnyov2et3lFj9xK4Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Staff/[uuid].vue?macro=true";
import { default as createcd_iwGNIWGSW6StV1NQGYBGub3r0IWMOVAxUGW9zyrgMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Staff/create.vue?macro=true";
import { default as fiscaldocuments3L2q8e9tSDG_KDBJw0abgicRjaivB4SBOnB5e3WfTLwMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Reporting/fiscaldocuments.vue?macro=true";
import { default as indexfHSYAEiG_f7gDLmeFpS_S7C19MSF6xh4_2LHlu_LTtYMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/MedicalVisits/[uuid]/index.vue?macro=true";
import { default as indexgwbD2oLQHvuR1Wl26Q4rSbGMVRXMaLVnRBY259oqbvEMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Creches/index.vue?macro=true";
import { default as codamQaS4MkVdGZs77A0i1EH0ho1Jeoe3OwDCnX8ol6z6NMMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Invoices/coda.vue?macro=true";
import { default as indexrdgWe02WXy5vW7JNbGKzD4vfluZrZNm_AD_H8IWME64Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Parents/index.vue?macro=true";
import { default as indexSTnI1LCdgkUppSyke_DctYBceiRodt9mJc6v4F_QESMMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/Emails/index.vue?macro=true";
import { default as indexXNKMD1D71iyaXSctaJxtTF8896tj7W9ylwKmMAbsMYsMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Calendar/index.vue?macro=true";
import { default as _91uuid_93rQvJ1GTR0kjT83Jftxp8FkGN8f0DX5cIl4QJCtq9v8cMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Creches/[uuid].vue?macro=true";
import { default as indexh_Rn8KEdLi_UUbLNHU_H0FY3_giiAvnQfShTswSK8qgMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Invoices/index.vue?macro=true";
import { default as indexncCFX7_aBW0pQ2odE8tHqto3oySp41Cl3UGltspz5fkMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Messages/index.vue?macro=true";
import { default as _91uuid_93N2z_ow1e7v2SVcWJRhxhyeAZxaxTl7INEMYe2i_JukEMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Parents/[uuid].vue?macro=true";
import { default as indexKnMqSmkxb2grvuzbjgkbWEazno1kVu6YQfvSVB__p0EMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Settings/index.vue?macro=true";
import { default as _91uuid_93kGIwcWtXtQlXl9DSGSoEXtNkOOBLTZE8VaqdgyAc1GAMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/Emails/[uuid].vue?macro=true";
import { default as createsxbo9pnbsi9HNw5_hA_BT_qSQLwYcjPY2YBYViiOYPQMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/Emails/create.vue?macro=true";
import { default as _91uuid_93vzONRRjgtLwtIR4hv_bfcYUmyj_4P2D_nO5W1GZlfzIMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Invoices/[uuid].vue?macro=true";
import { default as createPmUfFM4_E5EIw5g3_N3BNYe73x44uSqFFaKhAHSmkacMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Invoices/create.vue?macro=true";
import { default as _91uuid_93NDDQtIiGR3BSLasikHgejSodMgZT0SkOWMSS4vgVMUsMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Messages/[uuid].vue?macro=true";
import { default as createuj4Jy6nkM4bPLVxkm3iep_mRLP5XAlD3uzI2_1hMTcQMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Messages/create.vue?macro=true";
import { default as billingA_Vb4cWNdn4mk0n1SGtIjt4_MqYrsT9tUK9Ykk3HdJ8Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Reports/billing.vue?macro=true";
import { default as indexJk2N_Ntb0gZ_GUvqR3IBBquUJPHM3qERBWBvTzBTOYQMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Reports/aes/index.vue?macro=true";
import { default as indexWtdlr99nQ3sGInwLz8eClRjI3L3Yb6_qG5yuZHEFE8MMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Reports/sae/index.vue?macro=true";
import { default as indexMcHR5NIe7u9VqwxPPZ4DY2WHOwK8SYC7xhu7sh5n_BoMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Availability/index.vue?macro=true";
import { default as index1IM7CMaMAbSkPkNFEON5kG87RVwzzmhezLEBR4RUQF8Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Registrations/index.vue?macro=true";
import { default as attendancesBUmSlo0e7zpG_MB3LrpnXydRJ6WbGZ53stKQtcDiSHUMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Reports/attendances.vue?macro=true";
import { default as pro_45oneM4M5iuyfJyeBMpVpy_wVNIb1r4JLjDL5B5pBB1hCDRcMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Reports/sae/pro-one.vue?macro=true";
import { default as _91uuid_93lQOvfkMQleAvJIUhmovvPkSi_bVc_ByOGMBc_tjcf_YMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Registrations/[uuid].vue?macro=true";
import { default as createuyuMx3fq_Whirme1hEhHSO1jBVvmZo_M48XbUSScwD8Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Registrations/create.vue?macro=true";
import { default as remunerationskXCyD_lv_qcxpHQWeS3gPK5tBK7DyPErNKDJqXXlC8oMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Reports/remunerations.vue?macro=true";
import { default as indexHx3u1IgFnfhozgt88tofUgfSTT0XvqqR21H2WeDU4lsMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/index.vue?macro=true";
import { default as finance_fExxcpTyQOFT_vU6y7WZ4vtazj47M5OuvRaBklzkBAMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/finance.vue?macro=true";
import { default as historyRJvYA4WnkRgvYrHhAY0BiX3XUxALhq5S0Nz89nZNhpcMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/history.vue?macro=true";
import { default as medicalAA_G2XWZfaiikfqq1_38juOOMcvqrJFQjOQ7EQofx30Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/medical.vue?macro=true";
import { default as parentsMRo18G_rElTMsJRnW7y2xKle2gVAIqxCuaBZhN_gK7QMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/parents.vue?macro=true";
import { default as calendarQZFcAMRQmID_iEmJtfgaANdda_CeBl7qvd3y6Y1nP14Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/calendar.vue?macro=true";
import { default as classroom5A_4bh72YlV4zkb1aNy4C8p8uk0zgdXL_22Uz_6GcXEMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/classroom.vue?macro=true";
import { default as documentszBaxEvbTFW_lDR_kWOVeyZHE_78_hfrg7uMGHtcFDbcMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/documents.vue?macro=true";
import { default as activitiesdIWTm9rfMbrlu6USaxFPzvtXvj7oW6rJLn2RxPEGBlsMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/activities.vue?macro=true";
import { default as registrationVAvmsZoqDCDfSXbYf2kR_IHVb7o3RzzmsesE1HwIrgAMeta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/registration.vue?macro=true";
import { default as indexlnB_SZUTA2q5cWd4krRM73_wDb2V5kHgvjzP_ROD7_0Meta } from "/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Babies/[baby_uuid]/registrations/[registration_uuid]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/index.vue")
  },
  {
    name: "Auth-login",
    path: "/Auth/login",
    meta: { ...(loginfIUgyOoDOmrorE44DBeFzPxHI5Bhn2PVy7Hh5_R_OpUMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Auth/login.vue")
  },
  {
    name: "Auth-logout",
    path: "/Auth/logout",
    meta: logoutW1jbM1MlsriK_tRTB1AGlvLZ4guWrzxKTBuJZ52vgoAMeta || {},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Auth/logout.vue")
  },
  {
    name: "Staff",
    path: "/Staff",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Staff/index.vue")
  },
  {
    name: "Stats",
    path: "/Stats",
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/index.vue")
  },
  {
    name: "Babies",
    path: "/Babies",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/index.vue")
  },
  {
    name: "Events",
    path: "/Events",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Events/index.vue")
  },
  {
    name: "Staff-uuid",
    path: "/Staff/:uuid()",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Staff/[uuid].vue")
  },
  {
    name: "Staff-create",
    path: "/Staff/create",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Staff/create.vue")
  },
  {
    name: "Stats-babies",
    path: "/Stats/babies",
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/babies.vue")
  },
  {
    name: "Tablet",
    path: "/Tablet",
    meta: { ...(indexJDchaii8f1lAVu2W22axQOR_amHTa8ldFPDFRy384cAMeta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/index.vue")
  },
  {
    name: "Babies-create",
    path: "/Babies/create",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/create.vue")
  },
  {
    name: "Demands",
    path: "/Demands",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Demands/index.vue")
  },
  {
    name: "Events-uuid",
    path: "/Events/:uuid()",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Events/[uuid].vue")
  },
  {
    name: "Invoices-coda",
    path: "/Invoices/coda",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Invoices/coda.vue")
  },
  {
    name: "Messages-id",
    path: "/Messages/:id()",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Messages/[id].vue")
  },
  {
    name: "Parents",
    path: "/Parents",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Parents/index.vue")
  },
  {
    name: "Reporting-one",
    path: "/Reporting/one",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Reporting/one.vue")
  },
  {
    name: "Stats-finance",
    path: "/Stats/finance",
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/finance.vue")
  },
  {
    name: "Stats-medical",
    path: "/Stats/medical",
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/medical.vue")
  },
  {
    name: "Activity",
    path: "/Activity",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Activity/index.vue")
  },
  {
    name: "Invoices",
    path: "/Invoices",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Invoices/index.vue")
  },
  {
    name: "Messages",
    path: "/Messages",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Messages/index.vue")
  },
  {
    name: "Payments",
    path: "/Payments",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Payments/index.vue")
  },
  {
    name: "Staff-calendar",
    path: "/Staff/calendar",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Staff/calendar.vue")
  },
  {
    name: "Attendances-day",
    path: "/Attendances/day",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Attendances/day.vue")
  },
  {
    name: "Babies-archived",
    path: "/Babies/archived",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/archived.vue")
  },
  {
    name: "Invoices-uuid",
    path: "/Invoices/:uuid()",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Invoices/[uuid].vue")
  },
  {
    name: "Invoices-create",
    path: "/Invoices/create",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Invoices/create.vue")
  },
  {
    name: "Messages-create",
    path: "/Messages/create",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Messages/create.vue")
  },
  {
    name: "Settings-creche",
    path: "/Settings/creche",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Settings/creche.vue")
  },
  {
    name: "Attendances-week",
    path: "/Attendances/week",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Attendances/week.vue")
  },
  {
    name: "Classrooms",
    path: "/Classrooms",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Classrooms/index.vue")
  },
  {
    name: "Settings-doctors",
    path: "/Settings/doctors",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Settings/doctors.vue")
  },
  {
    name: "Settings-finance",
    path: "/Settings/finance",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Settings/finance.vue")
  },
  {
    name: "Attendances",
    path: "/Attendances",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Attendances/index.vue")
  },
  {
    name: "Invoices-forecast",
    path: "/Invoices/forecast",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Invoices/forecast.vue")
  },
  {
    name: "Payments-balances",
    path: "/Payments/balances",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Payments/balances.vue")
  },
  {
    name: "Reporting-pro-one",
    path: "/Reporting/pro-one",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Reporting/pro-one.vue")
  },
  {
    name: "Settings-schedule",
    path: "/Settings/schedule",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Settings/schedule.vue")
  },
  {
    name: "Stats-attendances",
    path: "/Stats/attendances",
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/attendances.vue")
  },
  {
    name: "Tablet-Scan",
    path: "/Tablet/Scan",
    meta: { ...(indexZ27D4AG_QxPVxu3bKuHoAuETT_RNjvyKINHhJ6yS3YMMeta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Scan/index.vue")
  },
  {
    name: "Availability",
    path: "/Availability",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Availability/index.vue")
  },
  {
    name: "Organization",
    path: "/Organization",
    meta: { ...(indexECfQoPnSa3TsVpSYqxNXxim84ka2JDhO_KPWr79VAm8Meta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/index.vue")
  },
  {
    name: "Settings-documents",
    path: "/Settings/documents",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Settings/documents.vue")
  },
  {
    name: "Stats-availability",
    path: "/Stats/availability",
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/availability.vue")
  },
  {
    name: "Tablet-Staff",
    path: "/Tablet/Staff",
    meta: { ...(indexBwjpP9vedCiVPMN6tJHsDoTGsSSMvjgZlVODPi3ktFoMeta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Staff/index.vue")
  },
  {
    name: "MedicalVisits",
    path: "/MedicalVisits",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/MedicalVisits/index.vue")
  },
  {
    name: "Registrations",
    path: "/Registrations",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Registrations/index.vue")
  },
  {
    name: "Stats-registrations",
    path: "/Stats/registrations",
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Stats/registrations.vue")
  },
  {
    name: "Tablet-Babies",
    path: "/Tablet/Babies",
    meta: { ...(indexJL5HstLg6GcOZdjKe_dydnIujliMHDwt69uMR_l4kJIMeta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Babies/index.vue")
  },
  {
    name: "Tablet-Calendar-day",
    path: "/Tablet/Calendar/day",
    meta: { ...(day2S7RrA56_nSrJi5ivYHhyAjLnNokCclOUSyqTIER4_oMeta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Calendar/day.vue")
  },
  {
    name: "Tablet-Social",
    path: "/Tablet/Social",
    meta: { ...(index2IStO2v_10zA1lnTsLVo7whjmEjUrvULqKNNMxbiNLsMeta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Social/index.vue")
  },
  {
    name: "MedicalVisits-create",
    path: "/MedicalVisits/create",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/MedicalVisits/create.vue")
  },
  {
    name: "Parents-uuid",
    path: "/Parents/:uuid()",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Parents/[uuid]/index.vue")
  },
  {
    name: "Parents-uuid-mails",
    path: "/Parents/:uuid()/mails",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Parents/[uuid]/mails.vue")
  },
  {
    name: "Registrations-uuid",
    path: "/Registrations/:uuid()",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Registrations/[uuid].vue")
  },
  {
    name: "Registrations-create",
    path: "/Registrations/create",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Registrations/create.vue")
  },
  {
    name: "Tablet-Babies-uuid",
    path: "/Tablet/Babies/:uuid()",
    meta: { ...(_91uuid_93ZD6X0VMljC46KV9XFiK4eCldwFdY6lnVb07e1qGdf2EMeta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Babies/[uuid].vue")
  },
  {
    name: "Tablet-Babies-create",
    path: "/Tablet/Babies/create",
    meta: { ...(createyGYH3tsgrKf_lfyasCJwxCQPCJOihyFkZWytQDg6S2gMeta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Babies/create.vue")
  },
  {
    name: "Tablet-Messages-id",
    path: "/Tablet/Messages/:id()",
    meta: { ...(_91id_93zUdHeJjzYipxvgr2xuWZ3EIgn1cB_7301f6zTVF5pY8Meta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Messages/[id].vue")
  },
  {
    name: "Communications-social",
    path: "/Communications/social",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/social.vue")
  },
  {
    name: "Parents-uuid-babies",
    path: "/Parents/:uuid()/babies",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Parents/[uuid]/babies.vue")
  },
  {
    name: "Reporting-attendances",
    path: "/Reporting/attendances",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Reporting/attendances.vue")
  },
  {
    name: "Tablet-Activity",
    path: "/Tablet/Activity",
    meta: { ...(indexeSRv6WFPZxF7O4wFrofGHgpOdvtWejrnIaBKOKafAooMeta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Activity/index.vue")
  },
  {
    name: "Tablet-Calendar-month",
    path: "/Tablet/Calendar/month",
    meta: { ...(month0w69lidYs4hK6NTTD9e_mz5NMnARo9tIlhPWFYRhWmQMeta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Calendar/month.vue")
  },
  {
    name: "Tablet-Messages",
    path: "/Tablet/Messages",
    meta: { ...(indexKm20CTsB78biBmOvKYyxkLBPw4dtAGbGCq44zf_ab98Meta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Messages/index.vue")
  },
  {
    name: "Parents-uuid-account",
    path: "/Parents/:uuid()/account",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Parents/[uuid]/account.vue")
  },
  {
    name: "Settings-mailtemplates",
    path: "/Settings/mailtemplates",
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Settings/mailtemplates.vue")
  },
  {
    name: "Tablet-Messages-create",
    path: "/Tablet/Messages/create",
    meta: { ...(createsQAskPgJQe0KiHVqodpLv2qNnoL4FBYU9vgTbMWV2eMMeta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Messages/create.vue")
  },
  {
    name: "Classrooms-uuid",
    path: "/Classrooms/:uuid()",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Classrooms/[uuid]/index.vue")
  },
  {
    name: "Parents-uuid-invoices",
    path: "/Parents/:uuid()/invoices",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Parents/[uuid]/invoices.vue")
  },
  {
    name: "Reporting-remunerations",
    path: "/Reporting/remunerations",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Reporting/remunerations.vue")
  },
  {
    name: "Communications-Sms",
    path: "/Communications/Sms",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/Sms/index.vue")
  },
  {
    name: "Organization-Staff",
    path: "/Organization/Staff",
    meta: { ...(index1JtXoXL6qRFNLfKl_MBmRTkn_oBxUEFUvQDrLUTuLT0Meta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Staff/index.vue")
  },
  {
    name: "Registrations-aes-create",
    path: "/Registrations/aes/create",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Registrations/aes/create.vue")
  },
  {
    name: "Tablet-Attendances",
    path: "/Tablet/Attendances",
    meta: { ...(indexIGkoqZef63Tw_MJI7ZmUWNJtCWL2qd724OTC9U_Nmv8Meta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Attendances/index.vue")
  },
  {
    name: "Communications-Sms-uuid",
    path: "/Communications/Sms/:uuid()",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/Sms/[uuid].vue")
  },
  {
    name: "Communications-Sms-create",
    path: "/Communications/Sms/create",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/Sms/create.vue")
  },
  {
    name: "MedicalVisits-uuid-edit",
    path: "/MedicalVisits/:uuid()/edit",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/MedicalVisits/[uuid]/edit.vue")
  },
  {
    name: "Organization-Social",
    path: "/Organization/Social",
    meta: { ...(indexTk7_8Jc6Ss7r7FGDqr9PA5gSj9R7ma_3rBMMwTSrMfwMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Social/index.vue")
  },
  {
    name: "Organization-Staff-uuid",
    path: "/Organization/Staff/:uuid()",
    meta: { ...(_91uuid_93LHoDF82iZwJ7gEb2PBetmvAJ61Unnyov2et3lFj9xK4Meta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Staff/[uuid].vue")
  },
  {
    name: "Organization-Staff-create",
    path: "/Organization/Staff/create",
    meta: { ...(createcd_iwGNIWGSW6StV1NQGYBGub3r0IWMOVAxUGW9zyrgMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Staff/create.vue")
  },
  {
    name: "Reporting-fiscaldocuments",
    path: "/Reporting/fiscaldocuments",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Reporting/fiscaldocuments.vue")
  },
  {
    name: "MedicalVisits-uuid",
    path: "/MedicalVisits/:uuid()",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/MedicalVisits/[uuid]/index.vue")
  },
  {
    name: "Organization-Creches",
    path: "/Organization/Creches",
    meta: { ...(indexgwbD2oLQHvuR1Wl26Q4rSbGMVRXMaLVnRBY259oqbvEMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Creches/index.vue")
  },
  {
    name: "Organization-Invoices-coda",
    path: "/Organization/Invoices/coda",
    meta: { ...(codamQaS4MkVdGZs77A0i1EH0ho1Jeoe3OwDCnX8ol6z6NMMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Invoices/coda.vue")
  },
  {
    name: "Organization-Parents",
    path: "/Organization/Parents",
    meta: { ...(indexrdgWe02WXy5vW7JNbGKzD4vfluZrZNm_AD_H8IWME64Meta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Parents/index.vue")
  },
  {
    name: "Communications-Emails",
    path: "/Communications/Emails",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/Emails/index.vue")
  },
  {
    name: "Organization-Calendar",
    path: "/Organization/Calendar",
    meta: { ...(indexXNKMD1D71iyaXSctaJxtTF8896tj7W9ylwKmMAbsMYsMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Calendar/index.vue")
  },
  {
    name: "Organization-Creches-uuid",
    path: "/Organization/Creches/:uuid()",
    meta: { ...(_91uuid_93rQvJ1GTR0kjT83Jftxp8FkGN8f0DX5cIl4QJCtq9v8cMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Creches/[uuid].vue")
  },
  {
    name: "Organization-Invoices",
    path: "/Organization/Invoices",
    meta: { ...(indexh_Rn8KEdLi_UUbLNHU_H0FY3_giiAvnQfShTswSK8qgMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Invoices/index.vue")
  },
  {
    name: "Organization-Messages",
    path: "/Organization/Messages",
    meta: { ...(indexncCFX7_aBW0pQ2odE8tHqto3oySp41Cl3UGltspz5fkMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Messages/index.vue")
  },
  {
    name: "Organization-Parents-uuid",
    path: "/Organization/Parents/:uuid()",
    meta: { ...(_91uuid_93N2z_ow1e7v2SVcWJRhxhyeAZxaxTl7INEMYe2i_JukEMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Parents/[uuid].vue")
  },
  {
    name: "Organization-Settings",
    path: "/Organization/Settings",
    meta: { ...(indexKnMqSmkxb2grvuzbjgkbWEazno1kVu6YQfvSVB__p0EMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Settings/index.vue")
  },
  {
    name: "Communications-Emails-uuid",
    path: "/Communications/Emails/:uuid()",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/Emails/[uuid].vue")
  },
  {
    name: "Communications-Emails-create",
    path: "/Communications/Emails/create",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Communications/Emails/create.vue")
  },
  {
    name: "Organization-Invoices-uuid",
    path: "/Organization/Invoices/:uuid()",
    meta: { ...(_91uuid_93vzONRRjgtLwtIR4hv_bfcYUmyj_4P2D_nO5W1GZlfzIMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Invoices/[uuid].vue")
  },
  {
    name: "Organization-Invoices-create",
    path: "/Organization/Invoices/create",
    meta: { ...(createPmUfFM4_E5EIw5g3_N3BNYe73x44uSqFFaKhAHSmkacMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Invoices/create.vue")
  },
  {
    name: "Organization-Messages-uuid",
    path: "/Organization/Messages/:uuid()",
    meta: { ...(_91uuid_93NDDQtIiGR3BSLasikHgejSodMgZT0SkOWMSS4vgVMUsMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Messages/[uuid].vue")
  },
  {
    name: "Organization-Messages-create",
    path: "/Organization/Messages/create",
    meta: { ...(createuj4Jy6nkM4bPLVxkm3iep_mRLP5XAlD3uzI2_1hMTcQMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Messages/create.vue")
  },
  {
    name: "Organization-Reports-billing",
    path: "/Organization/Reports/billing",
    meta: { ...(billingA_Vb4cWNdn4mk0n1SGtIjt4_MqYrsT9tUK9Ykk3HdJ8Meta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Reports/billing.vue")
  },
  {
    name: "Organization-Reports-aes",
    path: "/Organization/Reports/aes",
    meta: { ...(indexJk2N_Ntb0gZ_GUvqR3IBBquUJPHM3qERBWBvTzBTOYQMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Reports/aes/index.vue")
  },
  {
    name: "Organization-Reports-sae",
    path: "/Organization/Reports/sae",
    meta: { ...(indexWtdlr99nQ3sGInwLz8eClRjI3L3Yb6_qG5yuZHEFE8MMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Reports/sae/index.vue")
  },
  {
    name: "Organization-Availability",
    path: "/Organization/Availability",
    meta: { ...(indexMcHR5NIe7u9VqwxPPZ4DY2WHOwK8SYC7xhu7sh5n_BoMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Availability/index.vue")
  },
  {
    name: "Organization-Registrations",
    path: "/Organization/Registrations",
    meta: { ...(index1IM7CMaMAbSkPkNFEON5kG87RVwzzmhezLEBR4RUQF8Meta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Registrations/index.vue")
  },
  {
    name: "Organization-Reports-attendances",
    path: "/Organization/Reports/attendances",
    meta: { ...(attendancesBUmSlo0e7zpG_MB3LrpnXydRJ6WbGZ53stKQtcDiSHUMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Reports/attendances.vue")
  },
  {
    name: "Organization-Reports-sae-pro-one",
    path: "/Organization/Reports/sae/pro-one",
    meta: { ...(pro_45oneM4M5iuyfJyeBMpVpy_wVNIb1r4JLjDL5B5pBB1hCDRcMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Reports/sae/pro-one.vue")
  },
  {
    name: "Organization-Registrations-uuid",
    path: "/Organization/Registrations/:uuid()",
    meta: { ...(_91uuid_93lQOvfkMQleAvJIUhmovvPkSi_bVc_ByOGMBc_tjcf_YMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Registrations/[uuid].vue")
  },
  {
    name: "Organization-Registrations-create",
    path: "/Organization/Registrations/create",
    meta: { ...(createuyuMx3fq_Whirme1hEhHSO1jBVvmZo_M48XbUSScwD8Meta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Registrations/create.vue")
  },
  {
    name: "Organization-Reports-remunerations",
    path: "/Organization/Reports/remunerations",
    meta: { ...(remunerationskXCyD_lv_qcxpHQWeS3gPK5tBK7DyPErNKDJqXXlC8oMeta || {}), ...{"middleware":"organization"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Organization/Reports/remunerations.vue")
  },
  {
    name: "Babies-baby_uuid-registrations-registration_uuid",
    path: "/Babies/:baby_uuid()/registrations/:registration_uuid()",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/index.vue")
  },
  {
    name: "Babies-baby_uuid-registrations-registration_uuid-finance",
    path: "/Babies/:baby_uuid()/registrations/:registration_uuid()/finance",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/finance.vue")
  },
  {
    name: "Babies-baby_uuid-registrations-registration_uuid-history",
    path: "/Babies/:baby_uuid()/registrations/:registration_uuid()/history",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/history.vue")
  },
  {
    name: "Babies-baby_uuid-registrations-registration_uuid-medical",
    path: "/Babies/:baby_uuid()/registrations/:registration_uuid()/medical",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/medical.vue")
  },
  {
    name: "Babies-baby_uuid-registrations-registration_uuid-parents",
    path: "/Babies/:baby_uuid()/registrations/:registration_uuid()/parents",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/parents.vue")
  },
  {
    name: "Babies-baby_uuid-registrations-registration_uuid-calendar",
    path: "/Babies/:baby_uuid()/registrations/:registration_uuid()/calendar",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/calendar.vue")
  },
  {
    name: "Babies-baby_uuid-registrations-registration_uuid-classroom",
    path: "/Babies/:baby_uuid()/registrations/:registration_uuid()/classroom",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/classroom.vue")
  },
  {
    name: "Babies-baby_uuid-registrations-registration_uuid-documents",
    path: "/Babies/:baby_uuid()/registrations/:registration_uuid()/documents",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/documents.vue")
  },
  {
    name: "Babies-baby_uuid-registrations-registration_uuid-activities",
    path: "/Babies/:baby_uuid()/registrations/:registration_uuid()/activities",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/activities.vue")
  },
  {
    name: "Babies-baby_uuid-registrations-registration_uuid-registration",
    path: "/Babies/:baby_uuid()/registrations/:registration_uuid()/registration",
    meta: {"middleware":"creche"},
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Babies/[baby_uuid]/registrations/[registration_uuid]/registration.vue")
  },
  {
    name: "Tablet-Babies-baby_uuid-registrations-registration_uuid",
    path: "/Tablet/Babies/:baby_uuid()/registrations/:registration_uuid()",
    meta: { ...(indexlnB_SZUTA2q5cWd4krRM73_wDb2V5kHgvjzP_ROD7_0Meta || {}), ...{"middleware":"tablet"} },
    component: () => import("/home/ploi/app.abcreche.com-deploy/app.abcreche.com/10042024_131856/app/pages/Tablet/Babies/[baby_uuid]/registrations/[registration_uuid]/index.vue")
  }
]